import { FuelIcon } from '@frete.com/fuel-react';
import React from 'react';
import * as Styled from './styled';

export const VerifiedBadge: React.FC = () => (
  <Styled.VerifiedBadgeWrapper data-testid="verified-badge">
    <FuelIcon name="verified-check" iconStyle="filled" size="medium" />
  </Styled.VerifiedBadgeWrapper>
);
